// Компонент для візуалізації сітки фільмів.
// Props:
// - movies: масив об'єктів Movie (дані з API).
// - onSelect: callback, викликається при кліку на картку фільму (передає Movie).
// Логіка:
// - Мапить масив movies в список елементів <li> з зображенням та заголовком.
import type { Movie } from "../../types/movie";
import styles from "./MovieGrid.module.css";

interface MovieGridProps {
    movies: Movie[];
    onSelect: (movie: Movie) => void;
}

const MovieGrid = ({ movies, onSelect }: MovieGridProps) => {
    return (
        <ul className={styles.grid}>
            {movies.map((movie) => (
                <li key={movie.id} onClick={() => onSelect(movie)}>
                    <div className={styles.card}>
                        <img
                            className={styles.image}
                            src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                            alt={movie.title}
                            loading="lazy"
                        />
                        <h2 className={styles.title}>{movie.title}</h2>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default MovieGrid;
